/** Desglose mensual referencial por plan (USD) */
export const planPricing = {
  bronce: {
    rotativa: 85,
    digest: 45,
    noticiero: 55,
    redes: 40,
    web: 65,
    micros: 0,
    segmento: 0,
  },
  plata: {
    rotativa: 110,
    digest: 90,
    noticiero: 65,
    redes: 80,
    web: 50,
    micros: 85,
    segmento: 0,
  },
  oro: {
    rotativa: 115,
    digest: 150,
    noticiero: 95,
    redes: 110,
    web: 45,
    micros: 125,
    segmento: 80,
  },
};

export const plansData = [
  {
    id: 'bronce',
    tag: 'Plan Bronce',
    title: 'Presencia esencial en el ecosistema TNO',
    highlight: false,
    features: [
      '6 impactos diarios en rotativa Radio Visual 24/7 (180 al mes) con mensaje de salud visual y marca Óptica Berlud.',
      '1 artículo SEO en TNO Digest: cuidado de la vista, lentes y tradición de la óptica.',
      '1 mención mensual en Noticias TNO con Sol Vargas (formato informativo de salud visual).',
      '2 inserts de marca en clips y piezas para redes del ecosistema TNO.',
      'Banner de aliado en el portal tnonetwork.com.',
    ],
    idealFor: 'Inicio en TNO: recordación diaria en señal, noticiero, SEO y presencia en redes.',
  },
  {
    id: 'plata',
    tag: 'Plan Plata',
    title: 'Autoridad digital y noticiero recurrente',
    highlight: true,
    features: [
      '12 impactos diarios en rotativa (360 al mes): máxima frecuencia en señal continua TNO Network.',
      '2 artículos mensuales en TNO Digest (SEO: salud visual, exámenes, monturas y servicios Berlud).',
      '1 cintillo semanal en Noticias TNO con Sol Vargas (4 al mes): tips de salud visual y llamados a la acción.',
      '6 inserts en redes: logo y claqueta en Reels, Shorts y derivados de programas.',
      '2 micros mensuales (estudio TNO o pieza con material gráfico de Berlud) en señal y redes.',
      'Banner web + menciones de apoyo en piezas del ecosistema.',
    ],
    idealFor: 'Top of mind en señal y noticiero, con video profesional sin necesidad de grabar en la óptica.',
  },
  {
    id: 'oro',
    tag: 'Plan Oro',
    title: 'Comercialización 360° — máximo alcance',
    highlight: false,
    features: [
      '12 impactos diarios en rotativa + refuerzo en momentos On-Demand de programas de bienestar.',
      '4 artículos mensuales en TNO Digest (cobertura SEO completa: prevención, estilo, tecnología óptica y servicios).',
      'Cintillo semanal en Noticias TNO (Sol Vargas) + bloque mensual de tips «Tu vista, tu bienestar» en antena.',
      '12 inserts en redes + publicación en cuentas oficiales TNO Network.',
      '4 micros mensuales (estudio, material de marca o entrevista con vocero por videollamada) + difusión TNO.',
      'Mención integrada en En Sintonía con tu Salud (Dra. Grecia Andreina) — 1 bloque mensual.',
      'Banner web, logo en espacio de aliados 24/7 y dossier editorial para canales propios de Berlud.',
    ],
    idealFor: 'Máximo alcance: noticiero, rotativa, Digest intensivo, inserts y paquete completo de micros en video.',
  },
];

export const getPlanTotal = (plan) => {
  const p = planPricing[plan.id] || {};
  const rotativa = p.rotativa || 0;
  const digest = p.digest || 0;
  const noticiero = p.noticiero || 0;
  const redes = p.redes || 0;
  const micros = p.micros || 0;
  const web = p.web || 0;
  const segmento = p.segmento || 0;

  return {
    rotativa,
    digest,
    noticiero,
    redes,
    micros,
    web,
    segmento,
    total: rotativa + digest + noticiero + redes + micros + web + segmento,
  };
};

export const INVENTARIO_LABELS = {
  rotativa: 'Rotativa Radio Visual 24/7',
  digest: 'TNO Digest (artículos SEO)',
  noticiero: 'Noticias TNO (Sol Vargas)',
  redes: 'Inserts en redes',
  micros: 'Micros en video',
};
